import { useMutation } from "@tanstack/react-query";

import { useCustomerService } from "contexts/ServiceContext";
import useRefetchUserManagementQueries from "../../useRefetchUserManagementQueries";
import { USER_MANAGEMENT_QUERY_KEY } from "./useUserManagementRoles";

const useRemoveUser = (
  userId: string | undefined,
  cardCode: string | undefined
) => {
  const customerService = useCustomerService();

  const refetchQueries = useRefetchUserManagementQueries();

  return useMutation({
    mutationKey: [USER_MANAGEMENT_QUERY_KEY, "delete", { cardCode, userId }],
    mutationFn: () =>
      userId && cardCode !== undefined
        ? customerService.removeUser(userId, cardCode)
        : Promise.reject(),
    onSuccess: refetchQueries,
  });
};

export default useRemoveUser;
